import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4fnic10q: FaireBrandEntity = {
  token: "b_4fnic10q",
  type: "brand",
  name: "Conscious Step",
  avatarUrl:
    "https://cdn.faire.com/fastly/bfa3ee072ff99bd2c7f908f2c60d0254f447d360c3fe50e852786a2df625409e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4b2190060ded8af7fb0451f984b98dd64c5703a760e6be2a0ea9f838df216bcf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bfa3ee072ff99bd2c7f908f2c60d0254f447d360c3fe50e852786a2df625409e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4b2190060ded8af7fb0451f984b98dd64c5703a760e6be2a0ea9f838df216bcf.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 257,
  isTopShop: true,
  isInsider: true,
  description:
    "Conscious Step supports people and the planet with every purchase. You can count on us for supreme comfort, ethical and sustainable production, and designs that make you smile; all while empowering non-profits to support their causes and communities. Our range of super soft socks and calming candles means we have something for anyone and everyone to help build a better world.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:13.425Z",
    importedBy: "entity-db-cli",
  },
};
